import { CommonModule } from '@angular/common';
import { Component, DestroyRef, Inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from "@angular/router";
import { ButtonModule } from '@coreui/angular-pro';
import { IconModule } from '@coreui/icons-angular';
import { BootstrapService } from 'app';
import { I18nService, TranslatePipe, TranslateService } from 'i18n';
import { Media, MediaService, MediaViewerComponent } from "media";
import { map } from 'rxjs';
import { ENVIRONMENT, Logger, SafeHtmlPipe } from "shared";

@Component({
    selector: 'entry-page',
    templateUrl: './entry-page.component.html',
    styleUrls: ['./entry-page.component.scss'],
    imports: [CommonModule, MediaViewerComponent, TranslatePipe, SafeHtmlPipe, ButtonModule, IconModule]
})
export class EntryPageComponent {

  media = signal<Media | null>(null);
  protected logger = new Logger('EntryPageComponent');

  constructor(protected router: Router,
              protected mediaService: MediaService,
              protected translateService: TranslateService,
              protected i18nService: I18nService,
              protected destroyRef: DestroyRef,
              protected bootstrapService: BootstrapService,
              @Inject(ENVIRONMENT) protected environment: any) {
    const handleMedia = (media: Media | null) => {
      if (media) {
        this.media.set({
          ...media, 
          actions: [
            {
              id:'login', 
              label: 'login.login',
              icon: 'cilKey'
            },
            {
              id:'register', 
              label: 'register.register_button',
              icon: 'cilUser'
            }
          ]
        });
      } else {
        this.onMediaAction('login');
      }
    };
    // this.mediaService
    //     .loadMedia(this.i18nService.getLanguage(), 'entry')
    //     .pipe(
    //       takeUntilDestroyed(this.destroyRef),
    //       map(items => {
    //         if (!items || items.length === 0) return null;
    //         return items.reduce((latest: Media, current: Media) => {
    //           const latestDate = new Date(latest.dateUpdated);
    //           const currentDate = new Date(current.dateUpdated);
    //           return currentDate > latestDate ? current : latest;
    //         });
    //       })
    //     ).subscribe((media) => {
    //       handleMedia(media ?? null)
    //     });
    const entry = this.bootstrapService.getSetting('entry');
    const media = entry?.media;
    handleMedia(media ?? null);
  }

  onMediaAction(actionId: string) {
    this.logger.debug('onMediaAction');
    if (actionId=='login') {
      this.router.navigateByUrl('/login');
    } else if (actionId=='register') {
      this.router.navigateByUrl('/register');
    }
  }
}
